// src/app/utils/get-value-by-path.ts
export function getValueByPath(obj: any, path: string): any {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj);
}
